import type { CruiseSectionTabValues } from 'constants/cruise'
import HorizontalContainerWithFadedOverflow from 'components/Common/HorizontalContainerWithFadedOverflow'
import ButtonGroupToggle from 'components/Common/ButtonGroupToggle'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'

type SectionTabs = {
  label: string
  id: CruiseSectionTabValues
}

interface Props {
  tabs: Array<SectionTabs>
  activeTab: CruiseSectionTabValues
  onTabsChange: (tab: CruiseSectionTabValues) => void
}

function CruiseContentTabs({
  tabs,
  activeTab,
  onTabsChange,
}: Props) {
  return (
    <>
      <CSSBreakpoint only="mobile">
        <HorizontalContainerWithFadedOverflow>
          <ButtonGroupToggle
            items={tabs}
            activeItem={tabs.find(tab => tab.id === activeTab)}
            onItemClick={(item) => onTabsChange(item.id as CruiseSectionTabValues)}
            fitButtons
          />
        </HorizontalContainerWithFadedOverflow>
      </CSSBreakpoint>

      <CSSBreakpoint min="tablet">
        <ButtonGroupToggle
          items={tabs}
          activeItem={tabs.find(tab => tab.id === activeTab)}
          onItemClick={(item) => onTabsChange(item.id as CruiseSectionTabValues)}
        />
      </CSSBreakpoint>
    </>
  )
}

export default CruiseContentTabs
